<script>
  import { onMount } from "svelte";
  import Notification from "../components/Notification.svelte";

  let showNotification = false;
  let message = "";
  let notificationType = "";

  export let isOpen = false;
  export let onUpdate = () => {};

  let newName = "";
  let newPassword = "";

  let userData = null;

  onMount(() => {
    userData = JSON.parse(localStorage.getItem("userData"));
  });

  const closeModal = () => {
    isOpen = false;
  };

  const handleConfirm = async () => {
    if (!newName.trim()) {
      message = "Name is required!";
      showNotification = true;
      notificationType = "danger";
      setTimeout(() => (showNotification = false), 3000);
      setTimeout(() => {
        successMessage = "";
        // window.location.href = "/";
      }, 3000);
      return;
    }

    try {
      const response = await fetch(
        "https://api.trulens.ae/api/auth/update-profile",
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: userData.token,
          },
          body: JSON.stringify({ name: newName, password: newPassword }),
        }
      );

      if (response.ok) {
        const updatedUser = await response.json();
        // Update only the name in local userData
        userData.user.name = newName;
        // Save the updated userData back to localStorage
        localStorage.setItem("userData", JSON.stringify(userData));
        // Notify the parent component to update the display

        showNotification = true;
        message = "Updated Successfully";
        notificationType = "success";
        setTimeout(() => (showNotification = false), 3000);
        setTimeout(() => {
          successMessage = "";
          // window.location.href = "/";
        }, 3000);

        onUpdate();
        // Close the modal
        closeModal();
        newName = "";
        newPassword = "";
      } else {
        const errorData = await response.json();
        alert(`Error: ${errorData.message}`);
      }
    } catch (error) {
      console.error("Error updating profile:", error);
      alert("Error updating profile. Please try again.");
    }
  };
</script>

<!-- <link
  rel="stylesheet"
  href="https://cdn.jsdelivr.net/npm/bootstrap@4.6.2/dist/css/bootstrap.min.css"
  integrity="sha384-xOolHFLEh07PJGoPkLv1IbcEPTNtaed2xpHsD9ESMhqIYd0nLMwNLD69Npy4HI+N"
  crossorigin="anonymous"
/> -->

<link
  href="https://fonts.googleapis.com/icon?family=Material+Icons"
  rel="stylesheet"
/>
<link
  rel="stylesheet"
  href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css"
/>

<div class="modal" style={isOpen ? "display: block;" : "display: none;"}>
  <div class="modal-content">
    <div class="input-group">
      <div class="input-icon">
        <i class="fas fa-user"></i>
      </div>
      <input
        type="text"
        id="newName"
        bind:value={newName}
        placeholder="Enter new name"
      />
    </div>
    <div class="input-group">
      <div class="input-icon">
        <i class="fas fa-lock"></i>
      </div>
      <input
        type="password"
        id="newPassword"
        bind:value={newPassword}
        placeholder="Enter new password"
      />
    </div>
    <br />
    <div class="button-container">
      <button class="cancel" on:click={closeModal}>Cancel</button>
      <button on:click={handleConfirm}>Confirm</button>
    </div>
  </div>
</div>
<Notification {message} show={showNotification} type={notificationType} />

<style>
  .modal {
    display: none;
    position: fixed;
    z-index: 1;
    left: 0;
    top: 0;
    width: 100%;
    height: 100vh;
    overflow: auto;
    background-color: rgba(0, 0, 0, 0.4);
  }

  .input-group {
    position: relative;
    margin-bottom: 15px;
  }

  .input-icon {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 25px;
    color: gray;
  }

  .input-group input[type="text"],
  .input-group input[type="password"] {
    width: calc(100% - 30px);
    padding-left: 40px;
    border-radius: 5px;
    margin: 5px 0;
    border: 1px solid #ffafcc;
    box-sizing: border-box;
  }

  .modal-content {
    background-color: #fefefe;
    margin: 15% auto;
    padding: 2%;
    border: 1px solid #888;
    width: 50%;
    max-width: 500px;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    text-align: center;
  }

  label {
    display: inline-block;
    text-align: left;
    width: 100%;
    margin-bottom: 10px;
  }

  input {
    width: 100%;
    padding: 8px;
    margin-bottom: 20px;
    box-sizing: border-box;
  }

  .button-container {
    display: flex;
    justify-content: center;
  }

  button {
    padding: 10px 20px;
    margin: 0 10px;
    background-color: #ff3c82;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }

  button:hover {
    background-color: #b683d4;
  }

  button.cancel {
    background-color: #ff0000;
  }

  button.cancel:hover {
    background-color: #850000;
  }

  @media (max-width: 768px) {
    .modal-content {
      width: 80%;
      margin: 50% auto;
      padding: 5%;
    }

    input {
      margin-bottom: 15px;
    }

    .close {
      font-size: 24px;
    }
  }
</style>
